<template>
  <div class="inner800">
    <h2 class="label mb10">전송 카테고리</h2>
    <div class="add">
      <input type="text" class="input" v-model="newCategory" @keyup.enter="setCategory" />
      <button type="submit" class="btn" @click="setCategory">추가</button>
    </div>
    <p v-if="isExist" class="colorRed mt5">{{message}}</p>
    <table class="table mt15">
      <tbody v-if="systemcategory.length > 0">
        <tr v-for="(cate, index) in systemcategory" :key="`system_${index}`" :class="{colorRed: exist(cate)}">
        <Item
          :data="cate"
          :index="index"
          :system="'system'" />
      </tr>
      <tr v-for="(cate, index) in categoryList" :key="`service_${index}`" :class="{colorRed: exist(cate)}">
        <Item
          :data="cate"
          :index="index"
          @updateItem="setCategory"
          @delItem="deleteItem" />
      </tr>
      </tbody>
      <tbody v-else>
        <tr class="noData">
          <td>카테고리를 먼저 추가하세요</td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btnFull btnPrimary mt15" @click="setCategory('update')">수정</button>
  </div>
</template>

<script>
import { baseURL } from '@/main'
import { mapGetters, mapActions } from 'vuex'
import UNIQUE from '@/common/unique'
import Item from '@/components/SuperAdmin/CategoryItem'

export default {
  name: 'Category',
  components: {
    Item
  },
  computed: {
    ...mapGetters({
      systemcategory: 'superadmin/systemcategory',
      category: 'superadmin/category'
    }),
    categoryList: {
      get () {
        // 실제 전송되는 페이지가 있는 순으로 정렬
        function sortList (arr, key) {
          const sort = function (a, b) {
            if (a[key] === null) {
              return 1
            } else if (b[key] === null) {
              return -1
            } else {
              return a[key] > b[key] ? -1 : a[key] < b[key] ? 1 : 0
            }
          }
          return arr.sort(sort)
        }
        return sortList(this.category, 'pages')
      },
      set (list) {
        this.$store.dispatch('superadmin/setCategory', list).then(() => {
          alert('카테고리가 삭제되었습니다')
          this.init()
        })
      }
    },
    isExist () {
      return this.categoryList.filter(x => x.label.toLowerCase() === this.newCategory.toLowerCase()).length > 0
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      categoryData: {
        id: '',
        label: '',
        pages: [],
        isDel: false
      },
      newCategory: '',
      message: '이미 존재하는 카테고리입니다'
    }
  },
  methods: {
    init () {
      this.newCategory = ''
      this.$store.dispatch('superadmin/getSystemCategory')
      this.$store.dispatch('superadmin/getCategory')
    },
    exist (cate) {
      return cate === this.newCategory
    },
    setCategory (update) {
      const isUpdate = update === 'update'
      const addData = {
        id: UNIQUE.mid(),
        label: this.newCategory,
        pages: []
      }
      const data = isUpdate ? this.categoryList : this.categoryList.concat([addData])
      const message = isUpdate ? '변경' : '추가'
      if (!this.isExist && window.confirm(`카테고리를 ${message}합니다`)) {
        this.$store.dispatch('superadmin/setCategory', data).then(() => {
          alert(`카테고리가 ${message}되었습니다`)
          this.init()
        })
      }
    },
    deleteItem (data) {
      if (window.confirm(`${data.label} 카테고리를 삭제합니다`)) {
        this.categoryList = this.categoryList.filter(x => x.id !== data.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add {
  position: relative;
  .btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }
  .input {
    padding-right: 130px;
  }
}
</style>
